import {
  SET_WISHLIST_ENTRIES_LOADING,
  UNSET_WISHLIST_ENTRIES_LOADING,
  SET_WISHLIST_UID,
  SET_WISHLIST_ENTRIES,
  DELETE_WISHLIST_ENTRY,
  NOTIFY_PRODUCT,
} from '@/account/context/wishlist/types';

export default (state, action) => {
  switch (action.type) {
    case SET_WISHLIST_ENTRIES_LOADING:
      return { ...state, entriesLoading: true };
    case UNSET_WISHLIST_ENTRIES_LOADING:
      return { ...state, entriesLoading: false };
    case SET_WISHLIST_UID:
      return {
        ...state,
        uid: action.payload,
        shareUrl: `${window.location.protocol}//${window.location.host}${DLG.config.encodedContextPath}/wishlist/${action.payload}`,
      };
    case SET_WISHLIST_ENTRIES:
      return { ...state, entries: action.payload };
    case DELETE_WISHLIST_ENTRY:
      return {
        ...state,
        entries: state.entries.filter(
          product => product.code !== action.payload,
        ),
      };
    case NOTIFY_PRODUCT:
      return {
        ...state,
        entries: state.entries.map(product => {
          if (product.code === action.payload) {
            product.stockNotificationAlreadyCreated = true;
          }
          return product;
        }),
      };
    default:
      return { ...state };
  }
};
